export const PRICE_HISTORY_PATH = "/price-history";

/** Chart data on this page starts from 1 December 2016. */
export const PRICE_HISTORY_CHART_START = "2016-12-01";

export const PRICE_HISTORY_METADATA = {
  title: "Zcash Price History Chart (Since 2016)",
  description:
    "Explore Zcash price history from 2016 to today. View yearly ZEC prices, charts, halvings, and key events that shaped its value.",
} as const;

export function isLiveChartRoute(pathname: string): boolean {
  return pathname === "/" || pathname === PRICE_HISTORY_PATH;
}

export function liveChartDefaultRange(pathname: string): "1D" | "ALL" {
  return pathname === PRICE_HISTORY_PATH ? "ALL" : "1D";
}
